import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import "./Navbar.css";
import ApplyModal from './ApplyModal';
import './ApplyModal.css';

const isHomePage = (pathname) => {
  const cleanPath = pathname.replace(/\/+$/, '') || '/';
  if (cleanPath === '/') return true;

  const schoolSlugs = [
    'alipurduar', 'bolpur', 'coochbehar', 'durgapur', 'falakata',
    'gangarampur', 'hoogly', 'jalpaiguri', 'kolaghat', 'krishnanagar',
    'midnapore', 'nabadwip', 'raiganj', 'raniganj', 'siliguri'
  ];
  if (schoolSlugs.some(slug => cleanPath === `/${slug}`)) {
    return true;
  }
  return false;
};

const NavbarCarousel = ({ schoolId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const location = useLocation();
  const isHome = isHomePage(location.pathname);
  const baseUrl = schoolId ? `/${schoolId}` : '';

  const toggleMenu = () => setIsMenuOpen((prev) => !prev);
  const closeMenu = () => {
    setIsMenuOpen(false);
    setOpenDropdown(null);
  };
  const toggleDropdown = (label) => {
    setOpenDropdown((prev) => (prev === label ? null : label));
  };
  const handleDropdownToggle = (label, event) => {
    event.preventDefault();
    event.stopPropagation();
    toggleDropdown(label);
  };

  return (
    <header className={`header-wrapper ${isHome ? 'home-header' : 'default-header'}`}>
      <div className="top-wrapper">
        <div className=" top">
          <div>
            <Link to={baseUrl || "/"} onClick={closeMenu}>
              <img src="/images/logo.png" className="top-logo" alt="Logo" />
            </Link>
          </div>
          <div className="brand-name">
            <h1 >Techno India Group Public School</h1>
          </div>
          <div>
            <a href="#" onClick={(e) => { e.preventDefault(); setIsModalOpen(true); }} className="btn-com">
              Admissions Open 2026-27
            </a>
          </div>
        </div>
      </div>
      {/* Navbar */}
      <nav className="navbar navbar-expand-xl bg-body-tertiary">
        <div className="container-fluid">
          <Link className="navbar-brand navbar-logo-brand" to={baseUrl || "/"} onClick={closeMenu}>
            <img src="/images/logo.png" alt="Logo" className="navbar-logo" />
          </Link>
          <button
            className={`navbar-toggler modern-hamburger ${isMenuOpen ? "is-active" : ""}`}
            type="button"
            onClick={toggleMenu}
            aria-controls="navbarSupportedContent"
            aria-expanded={isMenuOpen}
            aria-label="Toggle navigation"
          >
            <span className="hamburger-lines">
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
            </span>
          </button>
          <div
            className={`navbar-collapse ${isMenuOpen ? "mobile-open" : ""}`}
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <NavLink
                  className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
                  end
                  to={baseUrl || "/"}
                  onClick={closeMenu}
                >
                  Home
                </NavLink>
              </li>
              <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle"
                  to={`${baseUrl}/about`}
                  role="button"
                  aria-expanded={openDropdown === "About Us"}
                  onClick={(e) => handleDropdownToggle("About Us", e)}
                >
                  Our School
                </Link>

                <ul className={`dropdown-menu glass-element ${openDropdown === "About Us" ? "show" : ""}`}>
                  <li>
                    <NavLink
                      className={({ isActive }) => `dropdown-item ${isActive ? "active" : ""}`}
                      to={`${baseUrl}/about`}
                      onClick={closeMenu}
                    >
                      About Us
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className={({ isActive }) => `dropdown-item ${isActive ? "active" : ""}`}
                      to={`${baseUrl}/about`}
                      onClick={closeMenu}
                    >
                      Vision & Mission
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className={({ isActive }) => `dropdown-item ${isActive ? "active" : ""}`}
                      to={`${baseUrl}/about`}
                      onClick={closeMenu}
                    >
                      MD's Desk
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className={({ isActive }) => `dropdown-item ${isActive ? "active" : ""}`}
                      to={`${baseUrl}/about`}
                      onClick={closeMenu}
                    >
                      Management Committee
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className={({ isActive }) => `dropdown-item ${isActive ? "active" : ""}`}
                      to={`${baseUrl}/about`}
                      onClick={closeMenu}
                    >
                      Infrastructure
                    </NavLink>
                  </li>


                  <li>
                    <NavLink
                      className={({ isActive }) => `dropdown-item ${isActive ? "active" : ""}`}
                      to={`${baseUrl}/about`}
                      onClick={closeMenu}
                    >
                      Gallery
                    </NavLink>
                  </li>
                  {/* <li>
                    <NavLink
                      className={({ isActive }) => `dropdown-item ${isActive ? "active" : ""}`}
                      to={`${baseUrl}/about`}
                      onClick={closeMenu}
                    >
                      School Prospectus
                    </NavLink>
                  </li> */}
                </ul>
              </li>
              <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle"
                  to={`${baseUrl}/academics`}
                  role="button"
                  aria-expanded={openDropdown === "Academics"}
                  onClick={(e) => handleDropdownToggle("Academics", e)}
                >
                  Admissions
                </Link>

                <ul className={`dropdown-menu glass-element ${openDropdown === "Academics" ? "show" : ""}`}>
                  
                  <li>
                    <NavLink
                      className={({ isActive }) => `dropdown-item ${isActive ? "active" : ""}`}
                      to={`${baseUrl}/academics`}
                      onClick={closeMenu}
                    >
                      Eligibility Criteria
                    </NavLink>
                  </li>
                  {/* <li>
                    <NavLink
                      className={({ isActive }) => `dropdown-item ${isActive ? "active" : ""}`}
                      to={`${baseUrl}/academics`}
                      onClick={closeMenu}
                    >
                      Fee Structure
                    </NavLink>
                  </li> */}
                  {/* <li>
                    <NavLink
                      className={({ isActive }) => `dropdown-item ${isActive ? "active" : ""}`}
                      to={`${baseUrl}/academics`}
                      onClick={closeMenu}
                    >
                      Admission Form/Refund Policy
                    </NavLink>
                  </li> */}
                  <li>
                    <NavLink
                      className={({ isActive }) => `dropdown-item ${isActive ? "active" : ""}`}
                      to={`${baseUrl}/academics`}
                      onClick={closeMenu}
                    >
                      FAQs
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className={({ isActive }) => `dropdown-item ${isActive ? "active" : ""}`}
                      to={`${baseUrl}/academics`}
                      onClick={closeMenu}
                    >
                      Prospectus
                    </NavLink>
                  </li>
                  
                  <li>
                    <NavLink
                      className={({ isActive }) => `dropdown-item ${isActive ? "active" : ""}`}
                      to={`${baseUrl}/academics`}
                      onClick={closeMenu}
                    >
                      Apply Online
                    </NavLink>
                  </li>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle"
                  to={`${baseUrl}/admissions`}
                  role="button"
                  aria-expanded={openDropdown === "Admission"}
                  onClick={(e) => handleDropdownToggle("Admission", e)}
                >
                  Academics
                </Link>

                <ul className={`dropdown-menu glass-element ${openDropdown === "Admission" ? "show" : ""}`}>
                  {/* <li>
                    <NavLink
                      className={({ isActive }) => `dropdown-item ${isActive ? "active" : ""}`}
                      to={`${baseUrl}/admissions`}
                      onClick={closeMenu}
                    >
                      Curriculum
                    </NavLink>
                  </li> */}
                  {/* <li>
                    <NavLink
                      className={({ isActive }) => `dropdown-item ${isActive ? "active" : ""}`}
                      to={`${baseUrl}/admissions`}
                      onClick={closeMenu}
                    >
                      Classes Offered
                    </NavLink>
                  </li> */}
                  {/* <li>
                    <NavLink
                      className={({ isActive }) => `dropdown-item ${isActive ? "active" : ""}`}
                      to={`${baseUrl}/admissions`}
                      onClick={closeMenu}
                    >
                      Departments
                    </NavLink>
                  </li> */}
                  <li>
                    <NavLink
                      className={({ isActive }) => `dropdown-item ${isActive ? "active" : ""}`}
                      to={`${baseUrl}/admissions`}
                      onClick={closeMenu}
                    >
                      Academic Calendar
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className={({ isActive }) => `dropdown-item ${isActive ? "active" : ""}`}
                      to={`${baseUrl}/admissions`}
                      onClick={closeMenu}
                    >
                      Examination & Assessment
                    </NavLink>
                  </li>
                  {/* <li>
                    <NavLink
                      className={({ isActive }) => `dropdown-item ${isActive ? "active" : ""}`}
                      to={`${baseUrl}/admissions`}
                      onClick={closeMenu}
                    >
                      Faculty & Staff
                    </NavLink>
                  </li> */}
                  <li>
                    <NavLink
                      className={({ isActive }) => `dropdown-item ${isActive ? "active" : ""}`}
                      to={`${baseUrl}/admissions`}
                      onClick={closeMenu}
                    >
                      Library
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className={({ isActive }) => `dropdown-item ${isActive ? "active" : ""}`}
                      to={`${baseUrl}/admissions`}
                      onClick={closeMenu}
                    >
                      Science Laboratory
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className={({ isActive }) => `dropdown-item ${isActive ? "active" : ""}`}
                      to={`${baseUrl}/admissions`}
                      onClick={closeMenu}
                    >
                      Science Lab (Atal Tinkering Lab)
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      className={({ isActive }) => `dropdown-item ${isActive ? "active" : ""}`}
                      to={`${baseUrl}/admissions`}
                      onClick={closeMenu}
                    >
                      Robotics Lab
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className={({ isActive }) => `dropdown-item ${isActive ? "active" : ""}`}
                      to={`${baseUrl}/admissions`}
                      onClick={closeMenu}
                    >
                      Computer Lab
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className={({ isActive }) => `dropdown-item ${isActive ? "active" : ""}`}
                      to={`${baseUrl}/admissions`}
                      onClick={closeMenu}
                    >
                      Smart Classsrooms
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className={({ isActive }) => `dropdown-item ${isActive ? "active" : ""}`}
                      to={`${baseUrl}/admissions`}
                      onClick={closeMenu}
                    >
                      Transport
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className={({ isActive }) => `dropdown-item ${isActive ? "active" : ""}`}
                      to={`${baseUrl}/admissions`}
                      onClick={closeMenu}
                    >
                      Medical Facilities
                    </NavLink>
                  </li>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle"
                  to={`${baseUrl}/life-at-tigps`}
                  role="button"
                  aria-expanded={openDropdown === "Beyond Academics"}
                  onClick={(e) => handleDropdownToggle("Beyond Academics", e)}
                >
                  News & Events
                </Link>

                <ul className={`dropdown-menu glass-element ${openDropdown === "Beyond Academics" ? "show" : ""}`}>
                  <li>
                    <NavLink
                      className={({ isActive }) => `dropdown-item ${isActive ? "active" : ""}`}
                      to={`${baseUrl}/life-at-tigps`}
                      onClick={closeMenu}
                    >
                      Achievements
                    </NavLink>
                  </li>
                </ul>
              </li>
              {/* <li className="nav-item">
                <NavLink
                  className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
                  to={`${baseUrl}/contact`}
                  onClick={closeMenu}
                >
                  News & Events
                </NavLink>
              </li> */}
              <li className="nav-item">
                <a className="nav-link" href="https://careers.tigps.in/" target="_blank" rel="noopener noreferrer" onClick={closeMenu}>
                  Career at TIGPS
                </a>
              </li>
              <li className="nav-item">
                <NavLink
                  className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
                  to={`${baseUrl}/contact`}
                  onClick={closeMenu}
                >
                  Contact Us
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <ApplyModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </header>
  );
};

export default NavbarCarousel;
